'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import AuthGateModal from '@/components/AuthGateModal';
import { useAuth } from '@/contexts/AuthContext';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [showAuthGate, setShowAuthGate] = useState(false);
  const { user, loading } = useAuth();
  const router = useRouter();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleOpenApp = (e: React.MouseEvent) => {
    e.preventDefault();
    if (!loading && user) {
      router.push('/app');
    } else {
      setShowAuthGate(true);
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-inkwell/95 backdrop-blur-md border-b-2 border-newsprint/10 shadow-[0_4px_20px_rgba(26,26,46,0.12)]'
            : 'bg-inkwell/80 backdrop-blur-sm'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <Link href="/home" className="flex items-center gap-3">
            <AppLogo size={28} text="QOLLECTIONS" />
          </Link>

          {/* Nav */}
          <nav className="hidden md:flex items-center gap-6">
            <Link href="/app" className="anchor-nav-item">My Collection</Link>
            <Link href="/app/profile" className="anchor-nav-item">Profile</Link>
          </nav>

          {/* CTA */}
          <div className="flex items-center gap-3">
            <Link
              href="/auth/login"
              className="px-4 py-2 rounded-lg border-2 border-newsprint/20 text-xs font-mono-data text-newsprint/60 hover:border-acid/40 hover:text-acid transition-colors"
            >
              SIGN IN
            </Link>
            <button
              onClick={handleOpenApp}
              className="acid-btn px-5 py-2 rounded-lg text-xs font-mono-data"
            >
              OPEN APP
            </button>
          </div>
        </div>
      </header>

      {showAuthGate && <AuthGateModal onClose={() => setShowAuthGate(false)} />}
    </>
  );
}